export const toTitleString = (str: string) => {
  if(!str) return ''
  const firstLetter = str[0].toUpperCase()
  return firstLetter + str.slice(1).toLowerCase()
}
